import React from "react";
import { IconButton, Tooltip } from "@mui/material";

const ActionIconButton = ({
  title = "",
  onClick,
  icon,
  color = "primary",
  size = "small",
  disabled = false,
}) => {
  return (
    <Tooltip title={title} arrow placement="top">
      <span>
        <IconButton
          onClick={onClick}
          color={color}
          size={size}
          disabled={disabled}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            backgroundColor: "background.paper",
            "&:hover": {
              backgroundColor: "primary.light",
              borderColor: "primary.main",
            },
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ActionIconButton;
